import script from "./LanguageDropdown.vue?vue&type=script&setup=true&lang=ts"
export * from "./LanguageDropdown.vue?vue&type=script&setup=true&lang=ts"

import "./LanguageDropdown.vue?vue&type=style&index=0&id=6b7f625f&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6b7f625f"]])

export default __exports__